class FacetFiltersForm extends HTMLElement{constructor(){super(),this.onActiveFilterClick=this.onActiveFilterClick.bind(this),this.debouncedOnSubmit=debounce(event=>{this.onSubmitHandler(event)},800),this.querySelector("form").addEventListener("input",this.debouncedOnSubmit.bind(this));const facetWrapper=this.querySelector("#FacetsWrapperDesktop");facetWrapper&&facetWrapper.addEventListener("keyup",onKeyUpEscape)}static setListeners(){const onHistoryChange=event=>{const searchParams=event.state?event.state.searchParams:FacetFiltersForm.searchParamsInitial;searchParams!==FacetFiltersForm.searchParamsPrev&&FacetFiltersForm.renderPage(searchParams,null,!1)};window.addEventListener("popstate",onHistoryChange)}static toggleActiveFacets(disable=!0){document.querySelectorAll(".js-facet-remove").forEach(element=>{element.classList.toggle("disabled",disable)})}static renderPage(searchParams,event,updateURLHash=!0){FacetFiltersForm.searchParamsPrev=searchParams;const sections=FacetFiltersForm.getSections(),countContainer=document.getElementById("ProductCount"),countContainerDesktop=document.getElementById("ProductCountDesktop");document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach(spinner=>spinner.classList.remove("hidden")),document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"),countContainer&&countContainer.classList.add("loading"),countContainerDesktop&&countContainerDesktop.classList.add("loading"),sections.forEach(section=>{const url=`${window.location.pathname}?section_id=${section.section}&${searchParams}`,filterDataUrl=element=>element.url===url;FacetFiltersForm.filterData.some(filterDataUrl)?FacetFiltersForm.renderSectionFromCache(filterDataUrl,event):FacetFiltersForm.renderSectionFromFetch(url,event)}),updateURLHash&&FacetFiltersForm.updateURLHash(searchParams)}static renderSectionFromFetch(url,event){fetch(url).then(response=>response.text()).then(responseText=>{const html=responseText;FacetFiltersForm.filterData=[...FacetFiltersForm.filterData,{html,url}],FacetFiltersForm.renderFilters(html,event),FacetFiltersForm.renderProductGridContainer(html),FacetFiltersForm.renderProductCount(html),typeof initializeScrollAnimationTrigger=="function"&&initializeScrollAnimationTrigger(html.innerHTML)})}static renderSectionFromCache(filterDataUrl,event){const html=FacetFiltersForm.filterData.find(filterDataUrl).html;FacetFiltersForm.renderFilters(html,event),FacetFiltersForm.renderProductGridContainer(html),FacetFiltersForm.renderProductCount(html),typeof initializeScrollAnimationTrigger=="function"&&initializeScrollAnimationTrigger(html.innerHTML)}static renderProductGridContainer(html){document.getElementById("ProductGridContainer").innerHTML=new DOMParser().parseFromString(html,"text/html").getElementById("ProductGridContainer").innerHTML,document.getElementById("ProductGridContainer").querySelectorAll(".scroll-trigger").forEach(element=>{element.classList.add("scroll-trigger--cancel")}),window.FloorEasyUnitPriceSort?.run()}static renderProductCount(html){const count=new DOMParser().parseFromString(html,"text/html").getElementById("ProductCount").innerHTML,container=document.getElementById("ProductCount"),containerDesktop=document.getElementById("ProductCountDesktop");container.innerHTML=count,container.classList.remove("loading"),containerDesktop&&(containerDesktop.innerHTML=count,containerDesktop.classList.remove("loading")),document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach(spinner=>spinner.classList.add("hidden"))}static renderFilters(html,event){const parsedHTML=new DOMParser().parseFromString(html,"text/html"),facetDetailsElementsFromFetch=parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),facetDetailsElementsFromDom=document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");Array.from(facetDetailsElementsFromDom).forEach(currentElement=>{Array.from(facetDetailsElementsFromFetch).some(({id})=>currentElement.id===id)||currentElement.remove()});const matchesId=element=>{const jsFilter=event?event.target.closest(".js-filter"):void 0;return jsFilter?element.id===jsFilter.id:!1},facetsToRender=Array.from(facetDetailsElementsFromFetch).filter(element=>!matchesId(element)),countsToRender=Array.from(facetDetailsElementsFromFetch).find(matchesId);if(facetsToRender.forEach((elementToRender,index)=>{if(document.getElementById(elementToRender.id))document.getElementById(elementToRender.id).innerHTML=elementToRender.innerHTML;else{if(index>0){const{className:previousElementClassName,id:previousElementId}=facetsToRender[index-1];if(elementToRender.className===previousElementClassName){document.getElementById(previousElementId).after(elementToRender);return}}elementToRender.parentElement&&document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender)}}),FacetFiltersForm.renderActiveFacets(parsedHTML),FacetFiltersForm.renderAdditionalElements(parsedHTML),countsToRender){const closestJSFilterID=event.target.closest(".js-filter").id;if(closestJSFilterID){FacetFiltersForm.renderCounts(countsToRender,event.target.closest(".js-filter")),FacetFiltersForm.renderMobileCounts(countsToRender,document.getElementById(closestJSFilterID));const newFacetDetailsElement=document.getElementById(closestJSFilterID),newElementSelector=newFacetDetailsElement.classList.contains("mobile-facets__details")?".mobile-facets__close-button":".facets__summary",newElementToActivate=newFacetDetailsElement.querySelector(newElementSelector),isTextInput=event.target.getAttribute("type")==="text";newElementToActivate&&!isTextInput&&newElementToActivate.focus()}}}static renderActiveFacets(html){[".active-facets-mobile",".active-facets-desktop"].forEach(selector=>{const activeFacetsElement=html.querySelector(selector);activeFacetsElement&&(document.querySelector(selector).innerHTML=activeFacetsElement.innerHTML)}),FacetFiltersForm.toggleActiveFacets(!1)}static renderAdditionalElements(html){[".mobile-facets__open",".mobile-facets__count",".sorting"].forEach(selector=>{html.querySelector(selector)&&(document.querySelector(selector).innerHTML=html.querySelector(selector).innerHTML)}),document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()}static renderCounts(source,target){const targetSummary=target.querySelector(".facets__summary"),sourceSummary=source.querySelector(".facets__summary");sourceSummary&&targetSummary&&(targetSummary.outerHTML=sourceSummary.outerHTML);const targetHeaderElement=target.querySelector(".facets__header"),sourceHeaderElement=source.querySelector(".facets__header");sourceHeaderElement&&targetHeaderElement&&(targetHeaderElement.outerHTML=sourceHeaderElement.outerHTML);const targetWrapElement=target.querySelector(".facets-wrap"),sourceWrapElement=source.querySelector(".facets-wrap");sourceWrapElement&&targetWrapElement&&(target.querySelector("show-more-button .label-show-more.hidden")&&sourceWrapElement.querySelectorAll(".facets__item.hidden").forEach(hiddenItem=>hiddenItem.classList.replace("hidden","show-more-item")),targetWrapElement.outerHTML=sourceWrapElement.outerHTML)}static renderMobileCounts(source,target){const targetFacetsList=target.querySelector(".mobile-facets__list"),sourceFacetsList=source.querySelector(".mobile-facets__list");sourceFacetsList&&targetFacetsList&&(targetFacetsList.outerHTML=sourceFacetsList.outerHTML)}static updateURLHash(searchParams){history.pushState({searchParams},"",`${window.location.pathname}${searchParams&&"?".concat(searchParams)}`)}static getSections(){return[{section:document.getElementById("product-grid").dataset.id}]}createSearchParams(form){const formData=new FormData(form);return new URLSearchParams(formData).toString()}onSubmitForm(searchParams,event){FacetFiltersForm.renderPage(searchParams,event)}onSubmitHandler(event){event.preventDefault();const sortFilterForms=document.querySelectorAll("facet-filters-form form");if(event.srcElement.className=="mobile-facets__checkbox"){const searchParams=this.createSearchParams(event.target.closest("form"));this.onSubmitForm(searchParams,event)}else{const forms=[],isMobile=event.target.closest("form").id==="FacetFiltersFormMobile";sortFilterForms.forEach(form=>{isMobile?form.id==="FacetFiltersFormMobile"&&forms.push(this.createSearchParams(form)):(form.id==="FacetSortForm"||form.id==="FacetFiltersForm"||form.id==="FacetSortDrawerForm")&&forms.push(this.createSearchParams(form))}),this.onSubmitForm(forms.join("&"),event)}}onActiveFilterClick(event){event.preventDefault(),FacetFiltersForm.toggleActiveFacets();const url=event.currentTarget.href.indexOf("?")==-1?"":event.currentTarget.href.slice(event.currentTarget.href.indexOf("?")+1);FacetFiltersForm.renderPage(url)}}FacetFiltersForm.filterData=[],FacetFiltersForm.searchParamsInitial=window.location.search.slice(1),FacetFiltersForm.searchParamsPrev=window.location.search.slice(1),customElements.define("facet-filters-form",FacetFiltersForm),FacetFiltersForm.setListeners();class PriceRange extends HTMLElement{constructor(){super(),this.querySelectorAll("input").forEach(element=>{element.addEventListener("change",this.onRangeChange.bind(this)),element.addEventListener("keydown",this.onKeyDown.bind(this))}),this.setMinAndMaxValues()}onRangeChange(event){this.adjustToValidValues(event.currentTarget),this.setMinAndMaxValues()}onKeyDown(event){if(event.metaKey)return;const pattern=/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;event.key.match(pattern)||event.preventDefault()}setMinAndMaxValues(){const inputs=this.querySelectorAll("input"),minInput=inputs[0],maxInput=inputs[1];maxInput.value&&minInput.setAttribute("data-max",maxInput.value),minInput.value&&maxInput.setAttribute("data-min",minInput.value),minInput.value===""&&maxInput.setAttribute("data-min",0),maxInput.value===""&&minInput.setAttribute("data-max",maxInput.getAttribute("data-max"))}adjustToValidValues(input){const value=Number(input.value),min=Number(input.getAttribute("data-min")),max=Number(input.getAttribute("data-max"));value<min&&(input.value=min),value>max&&(input.value=max)}}customElements.define("price-range",PriceRange);class FacetRemove extends HTMLElement{constructor(){super();const facetLink=this.querySelector("a");facetLink.setAttribute("role","button"),facetLink.addEventListener("click",this.closeFilter.bind(this)),facetLink.addEventListener("keyup",event=>{event.preventDefault(),event.code.toUpperCase()==="SPACE"&&this.closeFilter(event)})}closeFilter(event){event.preventDefault(),(this.closest("facet-filters-form")||document.querySelector("facet-filters-form")).onActiveFilterClick(event)}}customElements.define("facet-remove",FacetRemove);

/*
 * Floor Easy unit-price sorter
 *
 * Shopify's native price sorting uses the lowest variant price. Flooring
 * products have a free Sample variant, so this sorter uses the displayed
 * per-square-metre price instead.
 *
 * The sorter retrieves every Shopify pagination page, sorts the full result,
 * and then displays only the products belonging to the current page. This
 * keeps Shopify's original pagination controls and page size intact.
 */
(() => {
  const supportedSorts = new Set(['price-ascending', 'price-descending']);
  const sortingClass = 'fe-unit-price-sorting';
  const styleId = 'fe-unit-price-sorting-style';
  let runSequence = 0;

  const installSortingStyle = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      html.${sortingClass} #product-grid {
        visibility: hidden;
      }
    `;
    document.head.appendChild(style);
  };

  const setSortingState = (isSorting, container) => {
    document.documentElement.classList.toggle(sortingClass, isSorting);

    if (container) {
      container.setAttribute('aria-busy', String(isSorting));
    }
  };

  const getSelectedSort = () =>
    new URLSearchParams(window.location.search).get('sort_by') ||
    document.querySelector('#SortBy')?.value ||
    document.querySelector('#SortBy-mobile')?.value;

  const readPrice = (item) => {
    const salePrice = item.querySelector(
      '.price__sale .price-item--last',
    );
    const regularPrice = item.querySelector(
      '.price__regular .price-item--regular',
    );
    const fallbackPrice = item.querySelector(
      '.price-item--last, .price-item--regular',
    );

    const priceText = (
      salePrice ||
      regularPrice ||
      fallbackPrice
    )?.textContent || '';

    const match = priceText.replace(/\s/g, '').match(/[\d.,]+/);

    return match
      ? Number.parseFloat(match[0].replace(/,/g, ''))
      : Number.NaN;
  };

  const readTitle = (item) =>
    item.querySelector('.card__heading a')?.textContent.trim() || '';

  const readKey = (item) => {
    const href = item
      .querySelector('.card__heading a[href*="/products/"]')
      ?.getAttribute('href');

    return href
      ? new URL(href, window.location.origin).pathname
      : '';
  };

  const readLastPage = (container) => {
    let lastPage = 1;

    container.querySelectorAll('.pagination a[href]').forEach((link) => {
      const page = Number.parseInt(
        new URL(link.href, window.location.origin).searchParams.get('page'),
        10,
      );

      if (Number.isFinite(page)) {
        lastPage = Math.max(lastPage, page);
      }
    });

    return lastPage;
  };

  const fetchPage = async (page, sectionId) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(
      `${url.pathname}?${url.searchParams.toString()}`,
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Collection page request failed: ${response.status}`,
      );
    }

    return new DOMParser().parseFromString(
      await response.text(),
      'text/html',
    );
  };

  const run = async () => {
    const runId = ++runSequence;
    const sortBy = getSelectedSort();

    if (!supportedSorts.has(sortBy)) {
      setSortingState(false);
      return;
    }

    const container = document.getElementById('ProductGridContainer');
    const grid = container?.querySelector('#product-grid');
    const sectionId = grid?.dataset.id;

    if (!container || !grid || !sectionId) {
      setSortingState(false, container);
      return;
    }

    installSortingStyle();
    setSortingState(true, container);

    const collectionElement = container.querySelector('.collection');
    collectionElement?.classList.add('loading');

    try {
      const currentPage =
        Number.parseInt(
          new URLSearchParams(window.location.search).get('page'),
          10,
        ) || 1;

      const lastPage = readLastPage(container);
      const pages = Array.from(
        { length: lastPage },
        (_, index) => index + 1,
      ).filter((page) => page !== currentPage);

      const documents = pages.length
        ? await Promise.all(
            pages.map((page) => fetchPage(page, sectionId)),
          )
        : [];

      if (runId !== runSequence) return;

      const pageDocuments = [document, ...documents];
      const pageItemGroups = pageDocuments.map((pageDocument) =>
        [...pageDocument.querySelectorAll('#product-grid > li')],
      );

      /*
       * The final Shopify page can contain fewer products, so use the largest
       * page as the collection's configured products-per-page value.
       */
      const pageSize = Math.max(
        1,
        ...pageItemGroups.map((items) => items.length),
      );

      const productItems = new Map();

      pageItemGroups.flat().forEach((item) => {
        const key = readKey(item);

        if (key) {
          productItems.set(key, item);
        }
      });

      const direction =
        sortBy === 'price-descending' ? -1 : 1;

      const sortedItems = [...productItems.values()].sort(
        (first, second) => {
          const firstPrice = readPrice(first);
          const secondPrice = readPrice(second);
          const firstHasPrice = Number.isFinite(firstPrice);
          const secondHasPrice = Number.isFinite(secondPrice);

          if (!firstHasPrice && !secondHasPrice) {
            return readTitle(first).localeCompare(readTitle(second));
          }

          if (!firstHasPrice) return 1;
          if (!secondHasPrice) return -1;

          return (
            direction * (firstPrice - secondPrice) ||
            readTitle(first).localeCompare(readTitle(second))
          );
        },
      );

      const pageStart = (currentPage - 1) * pageSize;
      const visibleItems = sortedItems.slice(
        pageStart,
        pageStart + pageSize,
      );

      visibleItems.forEach((item) => {
        item.classList.add('scroll-trigger--cancel');
        item.removeAttribute('data-cascade');
        item.style.removeProperty('--animation-order');
      });

      grid.replaceChildren(...visibleItems);
    } catch (error) {
      console.warn(
        'Floor Easy unit-price sorting could not complete.',
        error,
      );
    } finally {
      if (runId === runSequence) {
        collectionElement?.classList.remove('loading');
        setSortingState(false, container);
      }
    }
  };

  installSortingStyle();

  window.FloorEasyUnitPriceSort = { run };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
